import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import techAnimation from "../assests/UX&UIanimationblue.json";
import "./Uservices.css";
export default function Uservices() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div id="Website" class="Website wf-section">
      <div className="techHero1">
        <div className="topCurve"></div>
        <div className="techCardFull">
          <div className={`logo_curve1 ${isScrolled ? "logo_curve1_scrolled" : ""}`}></div>
          <div className={`logo_curve2 ${isScrolled ? "logo_curve2_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve1 ${isScrolled ? "menu-icon-curve1_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve2 ${isScrolled ? "menu-icon-curve2_scrolled" : ""}`}></div>
          <div className="menu-icon-curve1_MV"></div>
          <div className="menu-icon-curve2_MV"></div>
          <div className="logo_curve1_Mo"></div>
          <div className="logo_curve2_Mo"></div>
          <div className="techContent1_M">
            <h1 className="tech-title1_M">UX&UI<br/><span>DESIGN</span><br/>DEVELOPMENT</h1>
          </div>
          <div className="tech-animationu">
            <Lottie animationData={techAnimation} loop={true} speed={0.1} />
          </div>
        </div>
      </div>
      <div className="softwareSection">
      <h1 className="mainHeading1">
    UI/UX SERVICES WE RENDER
  </h1>
  <p className="subHeadingLinea">
  Our UI/UX team designs user interfaces for mobile apps andweb products that increase conversion, reduce cost of maintenance and build a consistent user experience.
</p>
  <div className="softwareGrid">
    <div className="softwareCard">
      <h2>UX Design</h2>
      <p>
        Define the way the end user will interact with the product.
      </p>
    </div>
    <div className="softwareCard">
      <h2>UI Design</h2>
      <p>
       Create the look and feel that enhances the overall user experience.
      </p>
    </div>
    <div className="softwareCard">
      <h2>Prototyping</h2>
      <p>
        Establish the entire app architecture and navigation components.
        </p>
    </div>
    <div className="softwareCard">
      <h2>Scalability</h2>
      <p>
        Deliver solutions with scalability in mind. To provide convenient usage and prevent crashes even if with 10K simultaneous users trying to access the web app.
      </p>
    </div>
    <div className="softwareCard">
      <h2>Information Architecture</h2>
      <p>
        Organize and structure the content and navigation of the product for optimal user experience.
      </p>
    </div>
    <div className="softwareCard">
      <h2>Branding</h2>
      <p>Make the product stand out through custom style, fonts, icons, and animations.</p>
    </div>
    </div>
    </div>
    </div>
  );
}

